import { TRootState } from 'Redux/Reducers';

export const getEventCount = (state: TRootState) => state.event.maxCount;
